<se-fe-card>
  <se-fe-card-header
    seFeDataTitle="Feature: Self Info"
    seFeDataSubtitle="Adding Info for Myself"
  ></se-fe-card-header>
  <se-fe-card-content>
    <se-po-household-setup-feature-self-info></se-po-household-setup-feature-self-info>
  </se-fe-card-content>
</se-fe-card>
